/**
 * Tabbed Cards
 */

// Vendors
import $ from 'jquery';

$('.tabbed-cards').each((index, element) => {
  $(element)
    .find('button')
    .on('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      var newText = $(e.target).text() == '+' ? '-' : '+';
      $(e.target).text(newText).parentsUntil('li').parent().toggleClass('open');
    });

  $(element)
    .find('nav.tabs a')
    .each((i, tabLink) => {
      $(tabLink).on('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        $(tabLink)
          .addClass('active')
          .parent()
          .siblings('li')
          .find('a')
          .removeClass('active');
        $(tabLink.hash).addClass('show').siblings().removeClass('show');
        $(element).find('select').get(0).selectedIndex = i;
        return false;
      });
    });

  $(element)
    .find('select')
    .on('change', (e) => {
      var tab = $(e.target).val();
      $(element).find('nav.tabs a').removeClass('active');
      $(element)
        .find('nav.tabs a[href="' + tab + '"]')
        .addClass('active');
      $(tab).addClass('show').siblings().removeClass('show');
    });
});
